export const SCOPE = "modules/insiders/";

export const GET_INSIDERS = SCOPE + "GET_INSIDERS";
export const GET_SUGGESTED_INSIDERS = SCOPE + "GET_SUGGESTED_INSIDERS";
export const GET_AVAILABLE_TIME = SCOPE + "GET_AVAILABLE_TIME";
export const ASK_SUGGESTION = SCOPE + "ASK_SUGGESTION";
export const GET_INSIDER = SCOPE + "GET_INSIDER";
export const GET_POSITIONS = SCOPE + "GET_POSITIONS";
export const ADD_POSITIONS = SCOPE + "ADD_POSITIONS";
export const GET_ALL_INSIDERS_REVIEWS = SCOPE + "GET_ALL_INSIDERS_REVIEWS";
export const GET_AVERAGE_INSIDER_RATING = SCOPE + "GET_AVERAGE_INSIDER_RATING";
export const DELETE_POSITION = SCOPE + "DELETE_POSITION";
export const GET_COUNTRIES = SCOPE + "GET_COUNTRIES";
export const GET_AVAILABILITIES = SCOPE + "GET_AVAILABILITIES";
export const GET_AVAILABILITY = SCOPE + "GET_AVAILABILITY";
export const ADD_AVAILABILITY = SCOPE + "ADD_AVAILABILITY";
export const DELETE_AVAILABILITY = SCOPE + "DELETE_AVAILABILITY";
export const GET_FILTERS = SCOPE + "GET_FILTERS";
export const GET_CITIES = SCOPE + "GET_CITIES";
export const GET_CALL_OBJECTIVES = SCOPE + "GET_CALL_OBJECTIVES";
export const GET_CALL_OBJECTIVE = SCOPE + "GET_CALL_OBJECTIVE";



// WEBPACK FOOTER //
// ./src/modules/insiders/types.js